import { HTMLAttributes, ReactElement } from 'react';
import styles from './CourseList.module.scss';
import CourseCard from '../CourseCard/CourseCard';
import { classes } from '../../../../lib/utils/cssUtils';
import { CardItemProps, GeneralCardItemProps, useFiltersView } from '../../../../lib/context/FiltersViewContext';
import VideoCard, { VideoCardProps } from '../VideoCard/VideoCard';
import { Api } from '../../../../lib/types/apiSpec';

export type CourseListProps = {
  courses: CardItemProps[];
} & HTMLAttributes<HTMLUListElement>;

const isVideoCardProps = (props: GeneralCardItemProps): props is VideoCardProps =>
  props.type === Api.LearningType.Video || props.type === Api.LearningType.Microlearning;

const CourseList = ({ courses, className }: CourseListProps): ReactElement => {
  const { hideImagesGridView, hideImagesListView, viewType } = useFiltersView();

  const commonElementProps = {
    hideImage: (hideImagesListView && viewType === 'list') || (hideImagesGridView && viewType === 'grid'),
  };

  return (
    <ul className={classes(styles.listBase, className, viewType === 'grid' ? styles.grid : styles.list)}>
      {courses.map((props, index) => (
        <li key={`${props.id}-${props.type}`} className={styles.itemWrapper}>
          {isVideoCardProps(props) ? (
            <VideoCard
              {...commonElementProps}
              {...props}
              className={classes({ [styles.listElement]: viewType === 'list' })}
              classNames={{ imageWrapper: styles.imageWrapper, content: styles.content }}
              position={index}
            />
          ) : (
            <CourseCard
              {...props}
              {...commonElementProps}
              elementsClasses={{
                root: classes(styles.itemRoot, { [styles.listElement]: viewType === 'list' }),
                image: classes(styles.imageWrapper, {
                  [styles.eventImageWrapper]: props.type === Api.LearningType.Event,
                }),
                content: styles.content,
              }}
              position={index}
              variant="shadowed"
            />
          )}
        </li>
      ))}
    </ul>
  );
};

export default CourseList;
